import { FavouritesContact } from '@oh-vcp/components-common';
import { useQuery } from 'react-query';
import { apiGet } from './apiService';

const fetchFavourites = async (): Promise<FavouritesContact[]> => {
  return apiGet('favorites/?fetchPresence=false');
};

const useFavourites = (isEnabled: boolean) => {
  return useQuery({
    queryFn: fetchFavourites,
    queryKey: ['useFavourites'],
    enabled: isEnabled
  });
};

export default useFavourites;
